import { render, staticRenderFns } from "./AccountNewAddress.vue?vue&type=template&id=2563ccf4&scoped=true&lang=pug"
import script from "./AccountNewAddress.vue?vue&type=script&lang=js"
export * from "./AccountNewAddress.vue?vue&type=script&lang=js"
import style0 from "./AccountNewAddress.vue?vue&type=style&index=0&id=2563ccf4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2563ccf4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2563ccf4')) {
      api.createRecord('2563ccf4', component.options)
    } else {
      api.reload('2563ccf4', component.options)
    }
    module.hot.accept("./AccountNewAddress.vue?vue&type=template&id=2563ccf4&scoped=true&lang=pug", function () {
      api.rerender('2563ccf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/account/AccountNewAddress.vue"
export default component.exports